
<!-- Horizontal cards start -->
<section id="horizontal-examples">
  <!-- <div class="row">
    <div class="col-12">
      <div class="content-header">Learning Material</div>
      <p class="content-sub-header mb-1">Learning Card </p>
    </div>
  </div> -->

  <div class="row match-height">
    <div class="col-xl-6 col-lg-12" *ngFor="let resource of resourcesData">
      <div class="card overflow-hidden">
        <div class="row">
          <div class="col-sm-6 col-12">
            <!-- <div class="card-img">
                 <img [src]="imgUrl+resource?.image" class="d-block w-100" alt="image">
            </div> -->
            <div class="avatar-content align-items-center">
              {{ resource?.content | shortName }}
            </div>
          </div>
          <div class="col-sm-6 col-12 d-flex align-items-center">
            <div class="card-body">
              <div class="align-self-center">
                <div class="px-3">
                  <h4 class="card-title mb-3">{{resource?.content}}</h4>
                  <p class="card-text">{{resource?.description | slice:0:150}}...</p>
                  <button type="button" class="btn btn-success" (click)="downloadPdf(resource?.documents)">Download</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-xl-6 col-lg-12">
      <div class="card overflow-hidden">
        <div class="row">
          <div class="col-sm-6 col-12 d-flex align-items-center">
            <div class="card-body">
              <div class="align-self-center">
                <div class="px-3">
                  <h4 class="card-title mb-3">Card title</h4>
                  <p class="card-text">Toffee sugar plum brownie pastry gummies jelly.</p>
                  <button type="button" class="btn btn-danger">Go somewhere</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-12">
            <div class="card-img">
              <img class="img-fluid" src="assets/img/photos/06.jpg" alt="Card image cap">
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
  <!-- <div class="row match-height">
    <div class="col-xl-6 col-lg-12">
      <div class="card overflow-hidden">
        <div class="row">
          <div class="col-sm-6 col-12">
            <div class="card-img">
              <ngb-carousel>
                <ng-template ngbSlide>
                  <img src="assets/img/photos/01.jpg" class="d-block w-100" alt="First slide">
                </ng-template>
                <ng-template ngbSlide>
                  <img src="assets/img/photos/10.jpg" class="d-block w-100" alt="Second slide">
                </ng-template>
                <ng-template ngbSlide>
                  <img src="assets/img/photos/11.jpg" class="d-block w-100" alt="Third slide">
                </ng-template>
              </ngb-carousel>
            </div>
          </div>
          <div class="col-sm-6 col-12 d-flex align-items-center">
            <div class="card-body">
              <div class="align-self-center">
                <div class="px-3">
                  <h4 class="card-title mb-3">Card title</h4>
                  <p class="card-text">Sweet halvah dragée jelly-o halvah carrot cake oat cake.</p>
                  <button type="button" class="btn btn-success">Go somewhere</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-lg-12">
      <div class="card overflow-hidden">
        <div class="row">
          <div class="col-sm-6 col-12 d-flex align-items-center">
            <div class="card-body">
              <div class="align-self-center">
                <div class="px-3">
                  <h4 class="card-title mb-3">Card title</h4>
                  <p class="card-text">Toffee sugar plum brownie pastry gummies jelly.</p>
                  <button type="button" class="btn btn-danger">Go somewhere</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-12">
            <div class="card-img">
              <img class="img-fluid" src="assets/img/photos/06.jpg" alt="Card image cap">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</section>
<!-- // Horizontal cards end -->

